import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Manifest } from 'services/action';
import { DatePicker, Form } from 'ui/components';

import { formatDate } from 'utilities/common';

const initialState = {
  schedule_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  total_cost: 0,
};

export const FormUpdatePartial = ({ onSubmit, data }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const [{ schedule_at, total_cost }, setState] = React.useState(initialState);

  const $handleSubmit = async (e) => {
    const payload = {
      schedule_at: schedule_at?.formatted,
      total_cost,
    };

    const req = await Dispatch(Manifest.$updatePartial(data?.id, payload));

    if (req?.message === 'success') {
      onSubmit();
    }
  };

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      schedule_at: {
        default: new Date(data?.schedule_at),
        formatted: formatDate(data?.schedule_at, 'YYYY-MM-DD'),
      },
      total_cost: data?.total_cost
    }));
  }, [data]);

  return (
    <Form autoComplete="off">
      <div className="row">
        <div className="col-md-6">
          <div className="mb-3">
            <label className="form-label required">Pilih Jadwal</label>
            <div
              className={
                StateForm?.errors?.schedule_at
                  ? 'border border-danger rounded'
                  : ''
              }
            >
              <DatePicker
                type="normal"
                value={schedule_at?.default}
                format="dd/MM/yyyy"
                onChange={(date) => {
                  setState((prevState) => ({
                    ...prevState,
                    schedule_at: {
                      default: date,
                      formatted: formatDate(date, 'YYYY-MM-DD'),
                    },
                  }));
                }}
                isShowTrigger
                error={StateForm?.errors?.schedule_at}
              />
            </div>

            {StateForm?.errors?.schedule_at ? (
              <div className="invalid-feedback" style={{ display: 'block' }}>
                {StateForm?.errors?.schedule_at}
              </div>
            ) : null}
          </div>
        </div>
        <div className="col-md-6">
          <Form.Input
            value={total_cost}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                total_cost: e.target.valueNumber,
              }))
            }
            type="number"
            label="Harga Pengiriman"
            error={StateForm?.errors?.total_cost}
          />
        </div>
      </div>

      <button
        className={
          StateForm?.loading
            ? 'btn-loading btn btn-primary px-3 w-100 mb-3'
            : 'btn btn-primary px-3 w-100 mb-3'
        }
        onClick={$handleSubmit}
        type="button"
        disabled={StateForm?.loading}
      >
        Simpan
      </button>
    </Form>
  );
};
